import { toast } from 'react-toastify';

import { getSerializedErrorMessage } from '../../../../../utils/errors';
import { decrementPendingGeneralInfoUpdates } from '../../../utils';

import type { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import type { IOnboardingQuestionnaireGeneralInfo } from '../../../../../pages/questionnaires/onboarding/components/forms/general/types';
import type { OnboardingQuestionnaireState } from '../../types';
import type { OnboardingGeneralThunks } from './types';

export function addOnboardingGeneralCases(
  builder: ActionReducerMapBuilder<OnboardingQuestionnaireState>,
  thunks: OnboardingGeneralThunks,
) {
  addUpdateOnboardingQuestionnaireGeneralInfoCases(builder, thunks);
}

function addUpdateOnboardingQuestionnaireGeneralInfoCases(
  builder: ActionReducerMapBuilder<OnboardingQuestionnaireState>,
  thunks: OnboardingGeneralThunks,
) {
  const { updateOnboardingQuestionnaireGeneralInfo } = thunks;

  builder
    .addCase(
      updateOnboardingQuestionnaireGeneralInfo.pending,
      (state: OnboardingQuestionnaireState) => {
        state.pendingGeneralInfoUpdateCount += 1;
        state.updateGeneralInfoLoading = true;
        state.error = null;
      },
    )
    .addCase(
      updateOnboardingQuestionnaireGeneralInfo.fulfilled,
      (
        state: OnboardingQuestionnaireState,
        action: PayloadAction<IOnboardingQuestionnaireGeneralInfo>,
      ) => {
        decrementPendingGeneralInfoUpdates(state);
        if (state.onboardingQuestionnaireDetails) {
          state.onboardingQuestionnaireDetails.general_info = action.payload;
        }
      },
    )
    .addCase(
      updateOnboardingQuestionnaireGeneralInfo.rejected,
      (state: OnboardingQuestionnaireState, action) => {
        state.error = action.error;
        decrementPendingGeneralInfoUpdates(state);
        toast.error(getSerializedErrorMessage(action.error));
      },
    );
}
